import React from 'react'
import KitchenNotes from '../components/KitchenNotes'
import NavbarWrapper from '../components/Navbar/NavbarWrapper'

function IncomingOrder() {
    return(
    <div>
        <NavbarWrapper /> 
        <KitchenNotes /> 
    </div> 
    )
}

export default IncomingOrder